const moduleRoute = {
    path: '/exames/visualizar/:labpacsItemId',
    component: () => import('./views/FileExamView.vue')
    
}

export default router => {
    router.addRoute(moduleRoute)
}